export default {
    MODULO_PRESCRIPTOR: 1,
    MODULO_ADMINISTRACION: 2
}
